// Shared constants for PaymentForm and ZeroAmountMessage width
export const PAYMENT_FORM_WIDTH = 450;
